
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { postAddHotGameType, updateHotGameType } from '@/api/hot-game-type';
import { iHotTypeGame } from '@/interface/hot-game';
import { toast } from '@/utils/common';
@Component
export default class EditGame extends Vue {
  @Prop() visible!: Boolean;
  @Prop() flag?: Number;
  @Prop() model!: iHotTypeGame;

  rules = {
    title: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
    index_category: [{ required: true, message: '请选择首页关联类别', trigger: 'blur' }],
  };

  categoryOptions: Array<{ label: string; val: number }> = [
    {
      label: '不关联',
      val: 0,
    },
    {
      label: '类别1',
      val: 1,
    },
    {
      label: '类别2',
      val: 2,
    },
    {
      label: '类别3',
      val: 3,
    },
  ];

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.saveHotGameType();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  @Emit()
  close() {}
  async saveHotGameType() {
    // console.log(this.model);
    // return;
    this.$msgbox({
      title: '提示',
      message: this.model.id <= 0 ? '确定添加?' : '确定修改?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          if (this.model.id > 0) {
            const resp = await updateHotGameType(this.model);
            if (resp.code) {
              toast(resp.msg, 'error');
            } else {
              toast('请到游戏入口的TAB页签，客户端显示不会马上生效，点击游戏入口配置页面的发布，确认后客户端显示生效');
            }
          } else {
            const resp = await postAddHotGameType(this.model);
            if (resp.code) {
              toast(resp.msg, 'error');
            } else {
              toast('请到游戏入口的TAB页签，客户端显示不会马上生效，点击游戏入口配置页面的发布，确认后客户端显示生效');
            }
          }
          instance.confirmButtonLoading = false;
          this.$emit('close');
          done();
        } else if (action === 'cancel') {
          instance.confirmButtonLoading = false;
          done();
        }
      },
    })
      .then(() => {
        // done();
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
}
